// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getTimestamp as getLegacyTimestamp, getType
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
} from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getText, getTimestamp
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
} from 'conversations-message-history/initial-message/operators/initialMessageGetters';
import { AGENT } from 'conversations-message-history/constants/messageUses';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import ContentText from '../primary-message/ContentText';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
// @ts-expect-error Could not find a declaration file for module '../p... Remove this comment to see the full error message
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import InitialMessageHeader from './InitialMessageHeader';
import styled from 'styled-components';
import AutomatedMessageAvatar from '../avatar/AutomatedMessageAvatar';
import AutomatedMessageContent from '../shared/components/AutomatedMessageContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "InitialMessage__StyledDiv",
  componentId: "sc-4lfh9c-0"
})(["display:flex;align-items:center;flex-direction:column;width:100%;"]);
const StyledContentColumn = styled.div.withConfig({
  displayName: "InitialMessage__StyledContentColumn",
  componentId: "sc-4lfh9c-1"
})(["display:flex;flex-direction:row;"]);
const InitialMessage = ({
  message,
  positionDescriptors
}) => {
  const isLegacyInitialMessage = Boolean(getType(message));
  let timestamp;
  if (isLegacyInitialMessage) {
    timestamp = getLegacyTimestamp(message);
  } else {
    timestamp = getTimestamp(message);
  }
  return /*#__PURE__*/_jsx(PrimaryMessage, {
    positionDescriptors: positionDescriptors,
    "data-test-id": "primary-message-initial",
    use: AGENT,
    children: /*#__PURE__*/_jsx(PrimaryMessageContent, {
      children: /*#__PURE__*/_jsxs(StyledContentColumn, {
        children: [/*#__PURE__*/_jsx(AutomatedMessageAvatar, {}), /*#__PURE__*/_jsxs(StyledDiv, {
          children: [/*#__PURE__*/_jsx(InitialMessageHeader, {
            timestamp: timestamp
          }), /*#__PURE__*/_jsx(AutomatedMessageContent, {
            children: /*#__PURE__*/_jsx(ContentText, {
              contentText: getText(message)
            })
          })]
        })]
      })
    })
  });
};
InitialMessage.displayName = 'InitialMessage';
InitialMessage.propTypes = {
  message: RecordPropType('InitialMessage').isRequired,
  positionDescriptors: PositionDescriptors.isRequired
};
export default InitialMessage;